module.exports = __webpack_public_path__ + "media/recipes/116-675ffc3f.png";